export default {
    active: 'ACTIVE',
    inactive:'INACTIVE',
    
}